import { Global } from '@emotion/react';
import { getColorValue } from '@shinetools/sunshine';

const NEW_FEATURE_INDICATOR_SIZE = '5px';

// https://developers.canny.io/install/changelog/customizations

const NewMessageIndicator = () => (
  <Global
    styles={`
    .Canny_BadgeContainer .Canny_Badge {
      /* override default values */
      top: inherit;
      right: inherit;
      border: inherit;
      padding: 0;

      top: 9px;
      left: 20px;
      width: ${NEW_FEATURE_INDICATOR_SIZE};
      height: ${NEW_FEATURE_INDICATOR_SIZE};
      border-radius: 50%;
      background-color: ${getColorValue('orange.700')};
    }
    `}
  />
);

export default NewMessageIndicator;
